import ArrowIcon from "assets/images/ArrowIcon";
import classNames from "classnames";
import {Link} from "react-router-dom";

import styles from "./CardLink.module.css";

type Props = {
  className?: string;
  cardLabel: string;
  cardImageLink: string;
  to: string;
};

export default function CardLink(props: Props) {
  return (
    <Link
      to={props.to}
      className={classNames(styles.cardLink, props.className)}
    >
      <div className={styles.cardInfo}>
        <span className={styles.cardLabel}>{props.cardLabel}</span>
        <ArrowIcon />
      </div>
      <div className={styles.cardImageContainer}>
        <img className={styles.cardImage} src={props.cardImageLink} alt="" />
      </div>
    </Link>
  );
}
